import { LLMModel } from "models/LLMs";
import BaseService from "./BaseService";

class LLMModelsService extends BaseService {
    protected urlBase: string = "api/LLMModels";

    public async getLLMModels(abortSignal?: AbortSignal): Promise<LLMModel[]> {
        const apiPath = "GetLLMModels";
        return this.get(new URLSearchParams(), apiPath, abortSignal);
    }
}

export default LLMModelsService;
